import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as style from './style.css';
import { clsx } from 'clsx';
import { UIText3 } from '@cian/ui-kit';
import { FloorsPanelTooltip } from '../FloorsPanelTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FloorsPanelItem = function FloorsPanelItem(_ref) {
  var _clsx, _clsx2;
  var floorNumber = _ref.floorNumber,
    floor = _ref.floor,
    onFloorChange = _ref.onFloorChange;
  var isCurrent = floor.number === floorNumber;
  var isDisabled = floor.availableRate === 0;
  var onClick = function onClick() {
    if (isDisabled || isCurrent) {
      return;
    }
    onFloorChange(floor.number);
  };
  var floorImageHeightName = 'floor-image-height-0';
  switch (floor.availableRate) {
    case 1:
      floorImageHeightName = 'floor-image-height-20';
      break;
    case 2:
      floorImageHeightName = 'floor-image-height-40';
      break;
    case 3:
      floorImageHeightName = 'floor-image-height-60';
      break;
    case 4:
      floorImageHeightName = 'floor-image-height-80';
      break;
    case 5:
      floorImageHeightName = 'floor-image-height-100';
      break;
  }
  var labelColor = isCurrent ? 'white_100' : 'black_100';
  return /*#__PURE__*/_jsx(FloorsPanelTooltip, {
    title: floor.description,
    isDisabled: isDisabled,
    children: /*#__PURE__*/_jsxs("div", {
      className: style['floor-image-container'],
      onClick: onClick,
      children: [/*#__PURE__*/_jsx("div", {
        className: clsx(style['floor-image'], style[floorImageHeightName], (_clsx = {}, _defineProperty(_clsx, style['floor-image-active'], isCurrent), _defineProperty(_clsx, style['floor-image-disabled'], isDisabled), _clsx))
      }), /*#__PURE__*/_jsx("div", {
        className: clsx(style['floor-image-label'], (_clsx2 = {}, _defineProperty(_clsx2, style['floor-image-label-active'], isCurrent), _defineProperty(_clsx2, style['floor-image-label-disabled'], isDisabled), _clsx2)),
        children: /*#__PURE__*/_jsx(UIText3, {
          textAlign: "center",
          color: labelColor,
          children: floor.number
        })
      })]
    })
  });
};